import moment from 'moment';
import { useMemo } from 'react';
export const usePermissions = (transportConditionSelectedItem, transportConditionItems, guardPermission, sensorPermission, relayPermission, transportSelectedDate) => {
    return useMemo(() => {
        const lastItem = transportConditionItems[transportConditionItems.length - 1];
        const isLatest = transportConditionItems.length > 0 &&
            transportConditionSelectedItem != null &&
            lastItem != null &&
            transportConditionSelectedItem.datetime === lastItem.datetime;
        // Диапазон по умолчанию: начало сегодняшних суток — 08:01 следующих суток; «реальный день» = текущий момент в выбранном диапазоне
        const isRealDay = (transportSelectedDate === null || transportSelectedDate === void 0 ? void 0 : transportSelectedDate[0]) != null &&
            (transportSelectedDate === null || transportSelectedDate === void 0 ? void 0 : transportSelectedDate[1]) != null &&
            moment().isBetween(moment(transportSelectedDate[0]), moment(transportSelectedDate[1]), null, '[]');
        return {
            guardDisabled: !guardPermission || !isLatest,
            sensorDisabled: !sensorPermission || !isLatest,
            relayDisabled: !relayPermission || !isLatest || !isRealDay,
        };
    }, [transportConditionSelectedItem, transportConditionItems, guardPermission, sensorPermission, relayPermission, transportSelectedDate]);
};
